/**
 * 角色管理 操作 筛选
 */
import React, {Component} from "react";
import {Button} from "antd";
import CmSearchInput from "../../../../../components/CmSearchInput/CmSearchInput";

export default class RoleListToolBar extends Component {
    render() {
        const {showRoleEdit, searchValue, onSearch, onSearchValueChange} = this.props;
        return (
            <div className="RoleList-ToolBar">
                <Button
                    onClick={() => showRoleEdit()} type={"primary"}>添加角色</Button>
                <div className="RoleList-right">
                    <CmSearchInput
                        searchValue={searchValue}
                        onSearch={onSearch}
                        onSearchValueChange={onSearchValueChange}
                        placeholder="请输入角色名称/编码"
                    />
                </div>
            </div>
        );
    }
}